import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { Wordmark } from '../components/site/Header';

export default function Privacy() {
  return (
    <div className="min-h-screen bg-background">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 py-12">
        <Link to="/" className="inline-flex items-center gap-2 text-sm text-muted-foreground hover:text-foreground" data-testid="privacy-back-link">
          <ArrowLeft className="w-4 h-4" /> Back to website
        </Link>
        <div className="mt-8"><Wordmark /></div>
        <h1 className="font-display font-semibold text-3xl sm:text-4xl tracking-tight mt-6">Privacy Policy</h1>
        <p className="text-sm text-muted-foreground mt-2">Melopa Invents Private Limited (“MELOPA INFRA”)</p>

        <div className="mt-8 space-y-6 text-sm leading-relaxed text-foreground/85">
          <p>
            This Privacy Policy explains how Melopa Invents Private Limited, operating under the brand MELOPA INFRA
            (“we”, “our”, “us”), collects and uses information submitted on melopainfra.com.
          </p>
          <h2 className="font-display font-semibold text-lg">Information we collect</h2>
          <p>
            When you submit a project enquiry, we collect the details you provide — such as your name, mobile number,
            optional email address, project type, approximate built-up area, number of floors, project location and project
            stage. We may also record standard technical information such as the page you arrived on, campaign parameters
            (UTM) and device type, used solely to understand how enquiries reach us.
          </p>
          <h2 className="font-display font-semibold text-lg">How we use it</h2>
          <p>
            Your information is used only to review your project requirement and contact you regarding your enquiry.
            We do not sell your personal information. We send only project-related communication.
          </p>
          <h2 className="font-display font-semibold text-lg">Data retention & contact</h2>
          <p>
            Enquiry records are retained for business purposes. To request correction or deletion of your data, contact us at{' '}
            <a href="mailto:hello@melopainfra.com" className="text-[#155E6D] underline">hello@melopainfra.com</a> or
            +91 79751 27454.
          </p>
        </div>

        <p className="mt-12 text-xs text-muted-foreground">
          MELOPA INFRA is a brand of Melopa Invents Private Limited. © {new Date().getFullYear()}
        </p>
      </div>
    </div>
  );
}
